import { ReactNode } from "react";
import { AlertCircleIcon } from "../icons";
import { useFieldStyles } from "./fieldStyles";

interface Props {
  label?: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
}

export default function FieldShell({ label, required, error, children }: Props) {
  const classes = useFieldStyles();
  return (
    <div className={classes.root}>
      {label && (
        <label className={classes.label}>
          {label}
          {required && <span className={classes.required}> *</span>}
        </label>
      )}
      <div className={classes.control}>{children}</div>
      {error && (
        <span className={classes.error} data-rv-error="true">
          <AlertCircleIcon size={13} />
          {error}
        </span>
      )}
    </div>
  );
}
